<template>
  <div id="receiptData" media="print">
    <!-- {{ ReservationDetails }} -->
    <body>
      <div id="page-wrap">
        <textarea id="header">INVOICE</textarea>

        <div id="identity">
          <textarea id="address">
Gnanams Hotel,
 299, 301 Clock Tower Rd, Jaffna
Phone: 0212 220 630</textarea
          >

          <div id="logo">
            <!-- <img  src="images/logo.png" alt="logo" /> -->

            <img src="" alt="" />
          </div>
        </div>

        <div style="clear: both"></div>

        <div>
          <table>
            <tr>
              <td class="meta-head">Reference Number</td>
              <td>
                <textarea
                  >{{ ReservationDetails.reference_number }}
                  </textarea
                >
              </td>
            </tr>
            <tr>
              <td class="meta-head">Date</td>
              <td>
                <textarea>{{ ReservationDetails.date | formatDate }}</textarea>
              </td>
            </tr>
            <tr>
              <td class="meta-head">Guest</td>
              <td>
                <div class="due">{{ ReservationDetails.guest.name }}</div>
              </td>
            </tr>
            <tr>
              <td class="meta-head">Total Amount</td>
              <td>
                <div class="due">{{ ReservationDetails.total_amount }}</div>
              </td>
            </tr>
          </table>
        </div>
        <table id="items">
          <tr>
            <th>Reference Number</th>

            <th>Date</th>
            <th>Item</th>
            <th>Quantity</th>
            <th>Cost</th>
          </tr>
          <tr></tr>

          <tr
            class="item-row"
            v-for="(item, index) in ReservationDetails.orders"
          >
            <td class="item-name">
              <div class="delete-wpr">
                <textarea>    {{ item.order_number }}</textarea>
              </div>
            </td>

            <td class="description">
              <textarea>

                  {{ item.date | formatDate }}
    </textarea
              >
            </td>
            <td>
              <div v-for="(order, index) in item.items" :key="index">
                <textarea class="cost">{{
                  order.dish
                    ? order.dish.name
                    : order.product
                    ? order.product.name
                    : '-'
                }}</textarea>
              </div>
            </td>
            <td>
              <div v-for="(order, index) in item.items" :key="index">
                <textarea class="qty">  {{ order.quantity }}</textarea>
              </div>
            </td>
            <td>
              <span class="price">{{ item.total_amount }}</span>
            </td>
          </tr>
        </table>

        <table id="items">
          <tr>
            <th>Room</th>
            <th>Date</th>
            <th>Cost</th>
            <th>Days</th>
            <th>Price</th>
          </tr>
          <tr></tr>

          <tr
            class="item-row"
            v-for="(item, index) in ReservationDetails.rooms"
          >
            <td class="item-name">
              <div class="delete-wpr">
                <textarea>    {{ item.room.name }}</textarea>
              </div>
            </td>

            <td class="description">
              <textarea>
    Check In :{{ item.check_in | formatDate }} -- Check Out:{{
                  item.check_out | formatDate
                }}</textarea
              >
            </td>
            <td>
              <textarea class="cost">{{ item.amount }}</textarea>
            </td>
            <td><textarea class="qty">5</textarea></td>
            <td>
              <span class="price">{{
                ReservationDetails.room_total_amount
              }}</span>
            </td>
          </tr>
        </table>

        <table id="items">
          <tr>
            <th>Date</th>
            <th>Reference Number</th>
            <th>Payment Type</th>
            <th>Amount</th>
            <th>Status</th>
          </tr>
          <tr></tr>

          <tr
            class="item-row"
            v-for="(item, index) in ReservationDetails.payments"
          >
            <td class="item-name">
              <div class="delete-wpr">
                <textarea>  {{ item.date_time | formatDate }} </textarea>
              </div>
            </td>

            <td class="description">
              <textarea>
     {{ item.reference_number ? item.reference_number : '-' }}</textarea
              >
            </td>
            <td>
              <textarea class="cost">{{ item.payment_type }}</textarea>
            </td>
            <td>
              <textarea class="qty">{{ item.amount }}</textarea>
            </td>
            <td>
              <span class="price">{{ item.status }}</span>
            </td>
          </tr>

          <tr>
            <td colspan="2" class="blank"></td>
            <td colspan="2" class="total-line">Order Total Amount</td>
            <td class="total-value">
              <div>{{ ReservationDetails.order_total_amount }}</div>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="blank"></td>
            <td colspan="2" class="total-line">Room Total Amount</td>
            <td class="total-value">
              <div>{{ ReservationDetails.room_total_amount }}</div>
            </td>
          </tr>

          <tr>
            <td colspan="2" class="blank"></td>
            <td colspan="2" class="total-line">Total Amount</td>

            <td class="total-value">
              <div>{{ ReservationDetails.total_amount }}</div>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="blank"></td>
            <td colspan="2" class="total-line">Amount Paid</td>

            <td class="total-value">
              <div>{{ ReservationDetails.paid_amount }}</div>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="blank"></td>
            <td colspan="2" class="total-line">Balance Due</td>
            <td class="total-value balance">
              <div class="due">
                {{
                  ReservationDetails.total_amount -
                  ReservationDetails.paid_amount
                }}
              </div>
            </td>
          </tr>
        </table>

        <div>
          <h5>Thank You</h5>
          <textarea>Powered by SpeedCodeLabs</textarea>
        </div>
      </div>
    </body>
  </div>
</template>

<script>
import axios from '@/plugins/axios';

export default {
  data() {
    return {
      ReservationDetails: [],
    };
  },
  created() {
    this.GetReservationDetails();
  },
  methods: {
    print() {
      this.$htmlToPaper('receiptData');
    },
    GetReservationDetails() {
      let id = this.$route.params.id;
      axios
        .get(`hms/web/reservations/${id}`)
        .then(res => {
          this.ReservationDetails = res.data;
          this.print();
        })
        .catch(err => {});
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}

body {
  font: 12px/1.8 'Poppins';
}
#page-wrap {
  width: 900px;
  margin: 0 auto;
}

textarea {
  border: 0;
  font: 14px Georgia, Serif;
  overflow: hidden;
  resize: none;
}
table {
  border-collapse: collapse;
}
table td,
table th {
  border: 1px solid black;
  padding: 5px;
}

#header {
  height: 35px;
  width: 100%;
  margin: 20px 0;
  background: #222;
  text-align: center;
  color: white !important;
  font: bold 18px Helvetica, Sans-Serif;
  text-decoration: uppercase;
  letter-spacing: 20px;
  padding: 8px 0px;
}

#address {
  width: 250px;
  height: 150px;
  float: left;
}
#customer {
  overflow: hidden;
}

#customer-title {
  font-size: 20px;
  font-weight: bold;
  float: left;
}

#meta {
  margin-top: 1px;
  width: 300px;
  float: right;
}
#meta td {
  text-align: right;
}
#meta td.meta-head {
  text-align: left;
  background: #eee;
}
#meta td textarea {
  width: 100%;
  height: 20px;
  text-align: right;
}

#items {
  clear: both;
  width: 100%;
  margin: 30px 0 0 0;
  border: 1px solid black;
}
#items th {
  background: #eee;
}
#items textarea {
  width: 80px;
  height: 50px;
}
#items tr.item-row td {
  border: 0;
  vertical-align: top;
}
#items td.description {
  width: 300px;
}
#items td.item-name {
  width: 175px;
}
#items td.description textarea,
#items td.item-name textarea {
  width: 100%;
}
#items td.total-line {
  border-right: 0;
  text-align: right;
}
#items td.total-value {
  border-left: 0;
  padding: 10px;
}
#items td.total-value textarea {
  height: 20px;
  background: none;
}
#items td.balance {
  background: #eee;
}
#items td.blank {
  border: 0;
}

#terms {
  text-align: center;
  margin: 20px 0 0 0;
}
#terms h5 {
  text-transform: uppercase;
  font: 13px Helvetica, Sans-Serif;
  letter-spacing: 10px;
  border-bottom: 1px solid black;
  padding: 0 0 8px 0;
  margin: 0 0 8px 0;
}
#terms textarea {
  width: 100%;
  text-align: center;
}
</style>
